export default __webpack_public_path__ + "static/rec-2000-ii-3603b4f468b6811c34b4d5e82c641960.png";